import { render, staticRenderFns } from "./InjectedObjectDrawer.vue?vue&type=template&id=7f31559a&scoped=true&"
import script from "./InjectedObjectDrawer.vue?vue&type=script&lang=ts&"
export * from "./InjectedObjectDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./InjectedObjectDrawer.vue?vue&type=style&index=0&id=7f31559a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f31559a",
  null
  
)

export default component.exports